var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('li',[_vm._v(" Comparison data consists of all previous "+_vm._s(_vm.selectedReferenceGroupText)+" matches with at least 85 minutes of match time. ")]),_c('li',[_vm._v("A player requires at least 4 full matches to have comparison data.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }